import { z } from 'zod';
import { Dateish } from './common';

export const KnowledgeFolderSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  description: z.string().nullable(),
  icon: z.string().nullable(),
  position: z.number().int(),
  knowledgeCount: z.number().int(),
});
export type KnowledgeFolder = z.infer<typeof KnowledgeFolderSchema>;

export const KnowledgeFolderBodySchema = z.object({
  name: z.string().min(1),
  description: z.string().nullish(),
  icon: z.string().nullish(),
});
export type KnowledgeFolderBody = z.infer<typeof KnowledgeFolderBodySchema>;

export const KnowledgeListItemSchema = z.object({
  id: z.number().int(),
  folderId: z.number().int(),
  folderName: z.string(),
  title: z.string(),
  /** texto puro truncado do corpo */
  excerpt: z.string(),
  tags: z.array(z.string()),
  isPublic: z.boolean(),
  authorName: z.string().nullable(),
  updatedAt: Dateish,
});
export type KnowledgeListItem = z.infer<typeof KnowledgeListItemSchema>;

export const KnowledgeFileSchema = z.object({
  id: z.number().int(),
  fileName: z.string(),
  size: z.number().int(),
  contentType: z.string(),
});
export type KnowledgeFile = z.infer<typeof KnowledgeFileSchema>;

export const KnowledgeDetailSchema = z.object({
  id: z.number().int(),
  folderId: z.number().int(),
  folderName: z.string(),
  title: z.string(),
  body: z.string(),
  tags: z.array(z.string()),
  isPublic: z.boolean(),
  publicSlug: z.string(),
  authorName: z.string().nullable(),
  views: z.number().int(),
  createdAt: Dateish,
  updatedAt: Dateish,
  files: z.array(KnowledgeFileSchema),
  feedback: z.object({
    yes: z.number().int(),
    no: z.number().int(),
    /** voto do usuário logado, se houver */
    mine: z.boolean().nullable(),
  }),
});
export type KnowledgeDetail = z.infer<typeof KnowledgeDetailSchema>;

export const KnowledgeBodySchema = z.object({
  folderId: z.number().int().positive(),
  title: z.string().min(1),
  body: z.string().default(''),
  tags: z.array(z.string().min(1)).max(20).default([]),
  isPublic: z.boolean().default(false),
});
export type KnowledgeBody = z.infer<typeof KnowledgeBodySchema>;

export const KnowledgeFeedbackBodySchema = z.object({ helpful: z.boolean() });

export const KnowledgeListQuerySchema = z.object({
  folder_id: z.coerce.number().int().positive().optional(),
  /** ILIKE em título, corpo e tags */
  search: z.string().optional(),
  sort: z.enum(['az', 'recent']).default('recent'),
});
export type KnowledgeListQuery = z.infer<typeof KnowledgeListQuerySchema>;

/** Artigo servido no link público (sem auth). */
export const PublicKnowledgeSchema = z.object({
  title: z.string(),
  body: z.string(),
  folderName: z.string(),
  authorName: z.string().nullable(),
  updatedAt: Dateish,
  files: z.array(KnowledgeFileSchema),
});
export type PublicKnowledge = z.infer<typeof PublicKnowledgeSchema>;

export const PublicKnowledgeListItemSchema = z.object({
  slug: z.string(),
  title: z.string(),
  folderName: z.string(),
  updatedAt: Dateish,
});
export type PublicKnowledgeListItem = z.infer<typeof PublicKnowledgeListItemSchema>;
